import { modifyState } from '~src/state';
import { showSidebarTab } from '~src/sidebarLegacy';

export async function stopChangeClothes() {
  // Reset state
  modifyState('ischangeClothesActive', false);
  modifyState('changeClothesOriginalImage', null);
  modifyState('changeClothesSelection', null);
  modifyState('changeClothesSelectedGarment', null);
  modifyState('changeClothesClothes', []);
  modifyState('changeClothesFiltersCategory', 'all');
  modifyState('changeClothesFiltersColor', 'all');

  // Go back to AI tools sidebar
  showSidebarTab('edit-images-ai');
}
